export enum SupportTicketStatus {
  Received = 'Received',
  WorkInProgress = 'Work-In-Progress',
  Completed = 'Completed',
}

export interface SupportTicketAttachment {
  id?: string;
  fileName?: string;
  name?: string;
  url?: string;
  fileUrl?: string;
  downloadUrl?: string;
  path?: string;
  size?: number;
  uploadedAt?: string | null;
}

export interface SupportTicketConversationItem {
  id: string;
  senderType: 'admin' | 'user' | string;
  senderId?: string;
  message: string;
  createdAt?: string | null;
  attachment?: SupportTicketAttachment | null;
}

export interface SupportTicket {
  id: string;
  ticketNo: string;
  title?: string;
  issue?: string;
  description: string;
  status: SupportTicketStatus | string;
  expectedCompletionDate?: string | null;
  createdOn?: string | null;
  createdAt?: string | null;
  completedAt?: string | null;
  requesterName?: string;
  requesterEmail?: string;
  lastAdminReply?: string;
  conversation?: SupportTicketConversationItem[];
  attachment?: SupportTicketAttachment | null;
  customerName?: string;
}

export interface SupportTicketListResponse {
  items: SupportTicket[];
  total: number;
  page: number;
  limit: number;
  hasMore: boolean;
}

export interface SupportTicketQueryParams {
  search?: string;
  status?: SupportTicketStatus | 'All' | '';
  page?: number;
  limit?: number;
}

export interface CreateSupportTicketPayload {
  issue: string;
  description: string;
  status: SupportTicketStatus | string;
  expectedCompletionDate?: string | null;
  attachmentId?: string | null;
  attachmentUrl?: string | null;
  attachmentName?: string | null;
}